/* eslint-disable react/prop-types */
// WindMachine.jsx
import React from 'react'

const WarningTriangleDefault = ({ style }) => <WarningTriangle style={style} />

export default WarningTriangleDefault

export const WarningTriangle = ({ height, width, style }) => {
  const svgStyle = { fill: '#284047', ...style }
  return (

    <svg width='62' height='57' viewBox='0 0 62 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <description>warning triangle icon</description>
      <title>warning triangle</title>
      <path d='M31 0L0 57H62L31 0Z' fill='#D00000' />
      <path d='M29 23H33V41H29V23Z' fill='white' />
      <path d='M31 47C29.8958 47 29 46.104 29 45.0001C29 43.896 29.8958 43 31 43C32.1042 43 33 43.896 33 45.0001C33 46.104 32.1042 47 31 47Z' fill='white' />
    </svg>

  )
}
